<template>
  <div class="loading">
    <span v-if="withTitle" class="box title" style="width: 25%" />
    <span class="box" style="width: 55%" />
    <span class="box" style="width: 75%" />
    <span class="box heading" style="width: 15%" />
    <span class="box" style="width: 40%" />
    <span class="box" style="width: 35%" />
    <span class="box" style="width: 86%" />
    <span class="box" style="width: 50%" />
    <span class="box heading" style="width: 15%" />
    <span class="box" style="width: 55%" />
    <span class="box" style="width: 40%" />
    <span class="box" style="width: 35%" />
    <span class="box" style="width: 50%" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    withTitle: { type: Boolean, default: true },
  },
});
</script>

<style scoped lang="scss">
div.loading {
  width: 100%;
  height: 50%;

  .box {
    display: block;
    height: 8px;
    border-radius: 2px;
    position: relative;
    overflow: hidden;
    margin-bottom: 12px;
    @include themed() {
      background-color: rgba(t($grey-30), 0.4);
    }

    &.title {
      margin-bottom: 32px;
      height: 20px;
    }

    &.heading {
      margin-top: 32px;
      height: 12px;
    }

    &::after {
      position: absolute;
      top: 0;
      inset-inline-end: 0;
      bottom: 0;
      inset-inline-start: 0;
      transform: translateX(-100%);
      background-image: linear-gradient(
        90deg,
        rgba(#fff, 0) 0,
        rgba(#fff, 0.2) 20%,
        rgba(#fff, 0.5) 60%,
        rgba(#fff, 0)
      );
      animation: shimmer 5s infinite;
      content: "";
    }

    @keyframes shimmer {
      100% {
        transform: translateX(100%);
      }
    }
  }
}
</style>
